
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface PlanData {
  label: string;
  value: number;
}

interface ProductPlanChartProps {
  productName: string;
  plans: PlanData[];
}

// Define colors based on plan type
const PLAN_COLORS: { [key: string]: string } = {
  'Yearly': '#008169',
  'Monthly': '#007DC3',
  'One-Time': '#E18B09'
};

export const ProductPlanChart = ({ productName, plans }: ProductPlanChartProps) => {
  // Only render if we have data
  if (!plans || plans.length === 0) {
    return null;
  }

  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">{productName} Plans</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[250px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={plans}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={90}
                fill="#9b87f5"
                dataKey="value"
                nameKey="label"
              >
                {plans.map((plan, index) => {
                  // Use specific color for plan type, fallback to default color if not found
                  const color = PLAN_COLORS[plan.label] || '#8884d8';
                  return (
                    <Cell key={`cell-${index}`} fill={color} />
                  );
                })}
              </Pie>
              <Tooltip formatter={(value) => [`${value}`, 'Subscriptions']} />
              <Legend 
                layout="horizontal" 
                verticalAlign="bottom" 
                align="center"
                formatter={(value) => <span className="text-sm">{value}</span>}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
